import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import {
  deleteStaff,
  deleteSubTask,
  doneSubTask,
  getSubTaskList,
  getSubTaskTempList,
  getTaskTempList,
  incompleteSubTask,
  removeTaksSubTask,
} from "../../../apiCall";
import toast from "react-hot-toast";
import { FormateDate, formatTimeDuration } from "../../../utils/FormateDate";

import { ExtractDays } from "../../../utils/ExtractDays";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useStateValue } from "../../../StateProvider";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import TruncateText from "../../../utils/TruncateText";
import { isAdmin } from "../../../utils/adminAccess";

const SubTaskList = ({
  setIsSaveAndAddSubtask,
  setIsSaveAndEditeSubtask,
  setEditSubTaskId,
  watchedFields,
  taskStatus,
}) => {
  const [{ sysConfig, userInfo }, dispatch] = useStateValue();

  const [searchParams] = useSearchParams();
  const subTaskId = searchParams.get("subTaskId");

  // const { temId, projectId } = useParams();
  const { taskId, projectId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const fetchSubTask = async () => {
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getSubTaskList(taskId);
      if (response?.status === 200) {
        setSubTaskList(response.data.data);
        setFilteredData(response.data.data);
      } else if (response?.response) {
        toast.error(response.response.data.status);
      }
      dispatch({ type: "SET_LOADING", status: false });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const deleteSubTask = async (id) => {
    // Perform the API call to fetch company info
    try {
      const response = await removeTaksSubTask(id);
      console.log(response);
      if (response?.status === 200) {
        refetch();
        toast.success(response.data.message);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const {
    isLoading,
    data: subTaskListData,
    refetch,
  } = useQuery({
    queryKey: ["sub-task-temp-list"],
    queryFn: fetchSubTask,
    enabled: taskId ? true : false,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [subTaskList, setSubTaskList] = useState([]);

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const userFilter = searchParams.get("user_filter"); // Replace 'param1' with your parameter name
  const statusFilter = searchParams.get("status_filter");
  const searchFilter = encodeURIComponent(searchParams.get("search_filter"));
  const projectUserFilter = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const projectStatusFilter = searchParams.get("project_status_filter");
  const projectSearchFilter = encodeURIComponent(
    searchParams.get("project_search_filter")
  );
  const taskType = searchParams.get("task_type");
  const userCode = searchParams.get("user_code");

  useEffect(() => {
    filterData(searchQuery);
  }, [searchQuery]);
  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(totalPageCount);
    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [currentPage, filteredData, sysConfig]);

  const filterData = (query) => {
    let filtered = subTaskList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Dscr.toLowerCase().includes(query) ||
          item.Name.toLowerCase().includes(query)
        //|| item.Mobile.includes(query)
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    if (subTaskId) {
      const targetIndex = filteredData.findIndex((item) => {
        return item.ID === parseInt(subTaskId);
      });
      console.log(targetIndex, filteredData,Number(sysConfig["Rows in MultiLine List"]));
      const pageNumber =
        Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) +
        1;
      console.log("page number", filteredData, targetIndex, pageNumber,currentPage);
      setCurrentPage(pageNumber);
    }
  }, [subTaskId, filteredData,sysConfig]);
  const removeSelection = () => {
    if (subTaskId) {
      navigate(
        `${
          location.pathname
        }?status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`,
        { replace: true }
      );
    }
  };
  // ************************************************************* subtask done **********************************
  const doneSubTsakStatus = async (id) => {
    try {
      const response = await doneSubTask(id);
      console.log(response);
      if (response?.status === 200) {
        toast.success(response.data.message);
        setScrollPosition(window.scrollY);
        refetch();
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const incompleteSubTsakStatus = async (id) => {
    try {
      const response = await incompleteSubTask(id);
      console.log(response);
      if (response?.status === 200) {
        setScrollPosition(window.scrollY);
        refetch();

        toast.success(response.data.message);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    // Restore the scroll position after data has been fetched
    window.scrollTo(0, scrollPosition);
  }, [subTaskListData]);
  // const [staffList, setStaffList] = useState(staffListData?.status === 200 ?staffListData?.data:[]);
  // ************************************************************* Confirmation modal start **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);

  const navigateToSubTaskWithId = (Id) => {
    if (statusFilter && userFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${
          userCode ? userCode : ""
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else if (statusFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&status_filter=${statusFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${
          userCode ? userCode : ""
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else if (userFilter) {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${
          userCode ? userCode : ""
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else {
      navigate(
        `/update${
          projectId ? `/project/${projectId}` : ""
        }/task/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${
          userCode ? userCode : ""
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    }
  };
  return (
    <div className="row" key="Sd">
      <div className="col-12">
        {/* card */}
        <div className="card ">
          <div className="card-header  ">
            <div className="d-flex justify-content-end ">
              {/* <div className=" d-flex justify-content-end ">
                <div
                  className="btn btn-success me-2"
                  style={{width:"210px"}}
                  onClick={()=>startTask(taskId)}

                >
                  Start
                </div>
              </div> */}
              <div className=" d-flex justify-content-end w-100 ">
                <button
                  className="btn btn-primary col-lg-2 col-md-4 col-12 "
                  disabled={
                    taskId
                      ? !(
                          (taskStatus === "Pending" ||
                            taskStatus === "In Process") &&
                          (userInfo?.user_code === watchedFields.TaskLead ||
                            userInfo?.user_code ===
                              watchedFields.parentProjectLead ||
                            isAdmin(userInfo))
                        )
                      : false
                  }
                  onClick={() => {
                    setIsSaveAndAddSubtask(true);
                  }}
                >
                  + Save and Add Sub Task
                </button>
              </div>
              {/* <div className=" d-flex justify-content-end ">
                <div
                  className="btn btn-success me-2"
                  style={{width:"210px"}}
                  checked={isSubtaskDone}
                  // onClick={()=>doneTask(taskId)}
                  onClick={()=>{ handleConfirmationShow();
                    setFunHandler({
                      fun: doneTask,
                      id: taskId,
                      title: "change task status to done",
                    });}}
                >
                 Done
                </div>
              </div> */}
            </div>
          </div>
          {!isLoading ? (
            <>
              <div className="card-body">
                <div className="table-responsive table-card">
                  {currentItems.length > 0 ? (
                    <table className="table text-nowrap mb-0 responsive-table sub-table table-centered table-hover">
                      <thead className="table-light">
                        <tr>
                          <th className="ps-6">Srl</th>
                          <th className="ps-6">Sub-Task</th>
                          <th className="ps-6">Allocate By</th>
                          <th>Done</th>
                          <th>Approx Duration</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.map((item, index) => (
                          <tr
                            key={`task-item-${item?.ID}-${index}`}
                            className={`${
                              parseInt(subTaskId) === item?.ID
                                ? "table-primary"
                                : ""
                            }`}
                          >
                            <td
                              data-label1="Srl"
                              style={{
                                width: "50px",
                                textWrap: "wrap",
                              }}
                            >
                              {item?.OrdNo}
                            </td>
                            <td className="name">
                              <div className="d-flex flex-column">
                                <strong
                                  className="cursor-pointer truncate"
                                  onClick={() => {
                                    navigateToSubTaskWithId(item.ID);
                                    // navigate(
                                    //   `/update/task/subtask/${item.ID}`
                                    // );

                                    setEditSubTaskId(item.ID);
                                    setIsSaveAndEditeSubtask(true);
                                  }}
                                >
                                  {item?.Name}
                                </strong>
                                <div className="truncate">
                                  <small>{item?.Dscr}</small>
                                </div>
                              </div>
                            </td>
                            <td
                              data-label1="Allocate By"
                              style={{ width: "120px" }}
                            >
                              {item.AllocBy}
                            </td>
                            <td
                              data-label1="Done"
                              style={{
                                width: "85px",
                                textWrap: "wrap",
                              }}
                            >
                              <div className="form-check form-switch  ">
                                <input
                                  className="form-check-input cursor-pointer"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchStock"
                                  checked={item?.Status?.text === "Done"}
                                  //chdefaultChecked=""
                                  disabled={
                                    !(
                                      (userInfo?.user_code ===
                                        item.SubTaskLead ||
                                        userInfo?.user_code ===
                                          watchedFields.TaskLead) &&
                                      !(
                                        taskStatus === "Done" ||
                                        taskStatus === "Cancelled" ||
                                        taskStatus === "Pending Review"
                                      )
                                    )
                                  }
                                  onClick={(e) => {
                                    if (e.target.checked) {
                                      handleConfirmationShow();
                                      setFunHandler({
                                        fun: doneSubTsakStatus,
                                        id: item.ID,
                                        title: "change sub task status to done",
                                      });
                                    } else {
                                      handleConfirmationShow();
                                      setFunHandler({
                                        fun: incompleteSubTsakStatus,
                                        id: item.ID,
                                        title:
                                          "change sub task status to Incomplete",
                                      });
                                    }
                                  }}
                                />
                              </div>
                              {/* {item?.Dscr} */}
                            </td>
                            <td
                              data-label1="Approx Duration"
                              style={{ width: "150px" }}
                            >
                              {item?.Duration === "0 days, 00:00"
                                ? "---"
                                : formatTimeDuration(item?.Duration)}
                            </td>

                            <td data-label1="Action" style={{ width: "115px" }}>
                              <div className="d-flex">
                                {(userInfo?.user_code ===
                                  watchedFields?.TaskLead ||
                                  userInfo?.user_code ===
                                    watchedFields?.AllocBy ||
                                  userInfo?.user_code === item?.AllocBy ||
                                  userInfo?.user_code === item?.SubTaskLead ||
                                  isAdmin(userInfo)) && (
                                  // &&
                                  // !(
                                  //   taskStatus === "Done" ||
                                  //   taskStatus === "Cancelled" ||
                                  //   taskStatus === "Pending Review"
                                  <div
                                    className={`btn btn-ghost btn-icon btn-sm rounded-circle border-0 texttooltip `}
                                    data-template="editOne"
                                    onClick={() => {
                                      navigateToSubTaskWithId(item.ID);
                                      // navigate(
                                      //   `/update/task/subtask/${item.ID}`
                                      // );

                                      setEditSubTaskId(item.ID);
                                      setIsSaveAndEditeSubtask(true);
                                    }}
                                  >
                                    <FaRegEdit
                                      size={20}
                                      style={{ fill: "#624bff" }}
                                    />
                                    <div id="editOne" className="d-none">
                                      <span>Edit</span>
                                    </div>
                                  </div>
                                )}

                                {(userInfo?.user_code ===
                                  watchedFields.TaskLead ||
                                  isAdmin(userInfo)) &&
                                  !(
                                    taskStatus === "Done" ||
                                    taskStatus === "Cancelled" ||
                                    taskStatus === "Pending Review"
                                  ) && (
                                    <div
                                      className={`btn btn-ghost btn-icon btn-sm rounded-circle border-0 texttooltip `}
                                      data-template="trashOne"
                                      onClick={() => {
                                        // deleteSubTask(item?.ID)
                                        handleConfirmationShow();
                                        removeSelection();
                                        setFunHandler({
                                          fun: deleteSubTask,
                                          id: item?.ID,
                                          title: "delete sub task",
                                        });
                                      }}
                                    >
                                      <MdOutlineDelete
                                        size={22}
                                        style={{ fill: "#d2042dc7" }}
                                      />
                                      <div id="trashOne" className="d-none">
                                        <span>Delete</span>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>No records found.!</strong>
                    </div>
                  )}
                </div>
              </div>
              {currentItems.length > 0 && (
                <div className="card-footer d-md-flex justify-content-between align-items-center">
                  <span>
                    Showing{" "}
                    {currentPage * Number(sysConfig["Rows in MultiLine List"]) -
                      Number(sysConfig["Rows in MultiLine List"]) +
                      1}{" "}
                    to{" "}
                    {currentPage *
                      Number(sysConfig["Rows in MultiLine List"]) >=
                    filteredData.length
                      ? filteredData.length
                      : currentPage *
                        Number(sysConfig["Rows in MultiLine List"])}{" "}
                    of {filteredData.length} entries
                  </span>
                  <nav className="mt-2 mt-md-0">
                    <ul className="pagination mb-0 ">
                      <li
                        className="page-item "
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (currentPage > 1) {
                            handlePageChange(currentPage - 1);
                            removeSelection();
                          }
                        }}
                      >
                        <div
                          className={`page-link ${
                            currentPage === 1 ? "disabled" : ""
                          } `}
                        >
                          Previous
                        </div>
                      </li>
                      {Array(totalPages ? totalPages : 0)
                        .fill()
                        .map((item, index) => (
                          <li
                            key={`page-${index}`}
                            style={{ cursor: "pointer" }}
                            className={`${
                              currentPage === index + 1
                                ? "page-item active"
                                : "page-item"
                            } ${
                              currentPage + 2 >= index + 1 &&
                              index + 1 > currentPage - 2
                                ? // currentPage - 2 < index + 1
                                  "d-block"
                                : "d-none"
                            }`}
                            onClick={() => {
                              handlePageChange(index + 1);
                              removeSelection();
                            }}
                          >
                            <div className="page-link">{index + 1}</div>
                          </li>
                        ))}

                      {/* <li className="page-item">
                            <a className="page-link" href="#!">
                              2
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#!">
                              3
                            </a>
                          </li> */}
                      <li className="page-item">
                        <div
                          style={{ cursor: "pointer" }}
                          className={`page-link ${
                            totalPages === currentPage ? "disabled" : ""
                          } `}
                          onClick={() => {
                            if (totalPages > currentPage) {
                              handlePageChange(currentPage + 1);
                              removeSelection();
                            }
                          }}
                        >
                          Next
                        </div>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </>
          ) : (
            <div className="m-5 fs-3">
              <strong>Fetching records..</strong>
            </div>
          )}
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default SubTaskList;
